// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback-form-container {
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.feedback-form-container h2 {
  margin-bottom: 2rem;
  color: #333;
  text-align: center;
}

.feedback-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-weight: 600;
  color: #444;
}

.feedback-type-buttons {
  display: flex;
  gap: 1rem;
  margin-bottom: 0.5rem;
}

.type-button {
  flex: 1 1;
  padding: 0.75rem;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 1rem;
}

.type-button:hover {
  border-color: #007bff;
  background: #f8f9fa;
}

.type-button.active {
  border-color: #007bff;
  background: #e7f1ff;
  color: #0056b3;
}

input[type="text"],
textarea,
select {
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.2s ease;
}

input[type="text"]:focus,
textarea:focus,
select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

textarea {
  resize: vertical;
  min-height: 120px;
}

.submit-button {
  padding: 1rem;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.submit-button:hover {
  background: #0056b3;
}

.feedback-success {
  text-align: center;
  padding: 3rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.feedback-success h2 {
  color: #28a745;
  margin-bottom: 1rem;
}

.feedback-success p {
  color: #666;
  margin-bottom: 2rem;
}

.feedback-success button {
  padding: 0.75rem 1.5rem;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.feedback-success button:hover {
  background: #218838;
}

/* File Upload Styles */
.file-upload-area {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.file-upload-button {
  display: inline-block;
  padding: 0.75rem 1rem;
  background: #f8f9fa;
  border: 2px dashed #007bff;
  border-radius: 6px;
  color: #007bff;
  cursor: pointer;
  text-align: center;
  transition: all 0.2s ease;
  font-weight: 500;
  width: fit-content;
}

.file-upload-button:hover {
  background: #e7f1ff;
  border-color: #0056b3;
  color: #0056b3;
}

.file-upload-hint {
  font-size: 0.875rem;
  color: #666;
  font-style: italic;
}

.file-preview {
  margin-top: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
}

.preview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  font-size: 0.875rem;
  color: #555;
}

.remove-file-button {
  padding: 0.25rem 0.5rem;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 0.75rem;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.remove-file-button:hover {
  background: #c82333;
}

.preview-image {
  max-width: 100%;
  max-height: 300px;
  width: auto;
  height: auto;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/components/FeedbackForm.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C","sourcesContent":[".feedback-form-container {\r\n  max-width: 800px;\r\n  margin: 2rem auto;\r\n  padding: 2rem;\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.feedback-form-container h2 {\r\n  margin-bottom: 2rem;\r\n  color: #333;\r\n  text-align: center;\r\n}\r\n\r\n.feedback-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 1.5rem;\r\n}\r\n\r\n.form-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.form-group label {\r\n  font-weight: 600;\r\n  color: #444;\r\n}\r\n\r\n.feedback-type-buttons {\r\n  display: flex;\r\n  gap: 1rem;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.type-button {\r\n  flex: 1;\r\n  padding: 0.75rem;\r\n  border: 2px solid #e0e0e0;\r\n  border-radius: 6px;\r\n  background: white;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  font-size: 1rem;\r\n}\r\n\r\n.type-button:hover {\r\n  border-color: #007bff;\r\n  background: #f8f9fa;\r\n}\r\n\r\n.type-button.active {\r\n  border-color: #007bff;\r\n  background: #e7f1ff;\r\n  color: #0056b3;\r\n}\r\n\r\ninput[type=\"text\"],\r\ntextarea,\r\nselect {\r\n  padding: 0.75rem;\r\n  border: 1px solid #ddd;\r\n  border-radius: 4px;\r\n  font-size: 1rem;\r\n  transition: border-color 0.2s ease;\r\n}\r\n\r\ninput[type=\"text\"]:focus,\r\ntextarea:focus,\r\nselect:focus {\r\n  outline: none;\r\n  border-color: #007bff;\r\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\r\n}\r\n\r\ntextarea {\r\n  resize: vertical;\r\n  min-height: 120px;\r\n}\r\n\r\n.submit-button {\r\n  padding: 1rem;\r\n  background: #007bff;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.submit-button:hover {\r\n  background: #0056b3;\r\n}\r\n\r\n.feedback-success {\r\n  text-align: center;\r\n  padding: 3rem;\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.feedback-success h2 {\r\n  color: #28a745;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.feedback-success p {\r\n  color: #666;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.feedback-success button {\r\n  padding: 0.75rem 1.5rem;\r\n  background: #28a745;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 1rem;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.feedback-success button:hover {\r\n  background: #218838;\r\n}\r\n\r\n/* File Upload Styles */\r\n.file-upload-area {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.file-upload-button {\r\n  display: inline-block;\r\n  padding: 0.75rem 1rem;\r\n  background: #f8f9fa;\r\n  border: 2px dashed #007bff;\r\n  border-radius: 6px;\r\n  color: #007bff;\r\n  cursor: pointer;\r\n  text-align: center;\r\n  transition: all 0.2s ease;\r\n  font-weight: 500;\r\n  width: fit-content;\r\n}\r\n\r\n.file-upload-button:hover {\r\n  background: #e7f1ff;\r\n  border-color: #0056b3;\r\n  color: #0056b3;\r\n}\r\n\r\n.file-upload-hint {\r\n  font-size: 0.875rem;\r\n  color: #666;\r\n  font-style: italic;\r\n}\r\n\r\n.file-preview {\r\n  margin-top: 1rem;\r\n  padding: 1rem;\r\n  background: #f8f9fa;\r\n  border-radius: 6px;\r\n  border: 1px solid #e0e0e0;\r\n}\r\n\r\n.preview-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 0.75rem;\r\n  font-size: 0.875rem;\r\n  color: #555;\r\n}\r\n\r\n.remove-file-button {\r\n  padding: 0.25rem 0.5rem;\r\n  background: #dc3545;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: 0.75rem;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.remove-file-button:hover {\r\n  background: #c82333;\r\n}\r\n\r\n.preview-image {\r\n  max-width: 100%;\r\n  max-height: 300px;\r\n  width: auto;\r\n  height: auto;\r\n  border-radius: 4px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
